<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      notFooterPadding
      :contentStyle="{'height': '100%'}"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main
          :table-shadow="false"
          :no-padding="true"
          parentTable
          >
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                v-model="filter.keyword"
                :options="[
                  {id: 0, text: 'SKU'},
                  {id: 1, text: '产品名称'},
                ]"
                :width="['100px', '150px']"
            ></gj-select-input>
            <gj-category-select
                v-model="filter.categoryId"
                multiple
                width="170px"
            ></gj-category-select>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              adaptParent
              :index="false"
              name="childProductAddModal"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :offset-height="54"
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "../../../../../../minxins";
  import {getChildProductPage} from "../../../../../../api/product";
  import {isMeaningful} from "../../../../../../utils/common";
  import {ProductEnum} from "../../../../../../utils/options";

  export default {
    name: "app-child-product-add-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      hideSkuList: {
        type: Array,
        default: () => []
      }
    },
    created() {

    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px'},
          {id: 'sku', header: 'SKU', field: 'sku', minWidth: '100px'},
          {id: 'name', header: '产品名称', field: 'name', minWidth: '150px'},
          {id: 'category', header: '品类', field: 'categoryName', minWidth: '100px'},
        ],
        filter: {
          keyword: {
            key: 0,
            value: null
          },
          categoryId: null
        }
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            keyword: {
              key: 0,
              value: null
            },
            categoryId: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            sku: this.filter.keyword.key === 0 ? this.filter.keyword.value : null,
            name: this.filter.keyword.key === 1 ? this.filter.keyword.value : null,
            categoryIds: isMeaningful(this.filter.categoryId) ? this.filter.categoryId : null,
            hideSkuList: this.hideSkuList,
            productType: ProductEnum.type.PRODUCT
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getChildProductPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
</style>
